const colors = {
    primary: `#384c8b`,
    secondary: `#384c8b`,
    text: `#959fc0`,
    water: `#29396b`,
    park: `#1b1b1b`,
    road: `#566bad`,
};

export default [
    {
        "elementType": `geometry`,
        "stylers": [{"color": colors.primary}],
    },
    {
        "elementType": `labels.icon`,
        "stylers": [{"visibility": `off`}],
    },
    {
        "elementType": `labels.text.fill`,
        "stylers": [{"color": colors.text}],
    },
    {
        "elementType": `labels.text.stroke`,
        "stylers": [{"color": colors.secondary}],
    },
    {
        "featureType": `administrative`,
        "elementType": `geometry`,
        "stylers": [
            {
                "color": colors.secondary,
            },
        ],
    },
    {
        "featureType": `administrative.country`,
        "elementType": `labels.text.fill`,
        "stylers": [
            {
                "color": colors.secondary,
            },
        ],
    },
    {
        "featureType": `administrative.land_parcel`,
        "stylers": [
            {
                "visibility": `off`,
            },
        ],
    },
    {
        "featureType": `poi.park`,
        "elementType": `geometry`,
        "stylers": [
            {
                "color": colors.secondary,
            },
        ],
    },
    {
        "featureType": `poi.park`,
        "elementType": `labels`,
        "stylers": [
            {
                "visibility": `off`,
            },
        ],
    },
    {
        "featureType": `poi.park`,
        "elementType": `labels.text.stroke`,
        "stylers": [
            {
                "color": colors.park,
            },
        ],
    },
    {
        "featureType": `road`,
        "elementType": `geometry.fill`,
        "stylers": [
            {
                "color": colors.road,
            },
        ],
    },
    {
        "featureType": `road.arterial`,
        "elementType": `geometry`,
        "stylers": [
            {
                "color": colors.road,
            },
        ],
    },
    {
        "featureType": `road.highway`,
        "elementType": `geometry`,
        "stylers": [
            {
                "color": colors.road,
            },
        ],
    },
    {
        "featureType": `road.highway.controlled_access`,
        "elementType": `geometry`,
        "stylers": [
            {
                "color": colors.road,
            },
        ],
    },
    {
        "featureType": `water`,
        "elementType": `geometry`,
        "stylers": [
            {
                "color": colors.water,
            },
        ],
    },

];